<div class="form-group" [formGroup]="customFormGroup">
  <label [for]="'input-'+id"  [id]="'sfklabel-'+id" data-cy="custom-label">
    {{ label }}
  </label>
  @if (!!infoText && infoText.length > 0) {
    <fa-icon class="infoIcon"
      [icon]="faInfo"
      [title]="infoText"
      data-cy="custom-info"
    ></fa-icon>
  }
  @if (environment.displayTextbausteinKeys) {
    <span>{{infoText}}</span>
  }
  <div style="position:relative;">
    @if (showMaxLength) {
      <div class="position-absolute" style="right: 5px; top: -19px">
        <span
          [class.text-muted]="currentLength / maxReferenceLength < 0.6"
				[class.text-warning]="
					currentLength / maxReferenceLength >= 0.6 && currentLength / maxReferenceLength < 1
				"
          [class.text-danger]="currentLength / maxReferenceLength >= 1"
          >
          {{ getCurrentLength() }}/{{ maxReferenceLength }}
        </span>
      </div>
    }
    <textarea contenteditable
      [formControlName]="id"
      class="form-control"
      rows="{{rows}}"
      cols="{{cols}}"
      [placeholder]="placeholder"
      [id]="htmlFieldName"
      [readonly]="readonly"
      [disabled]="disabled"
      [attr.maxlength]="maxLength"
      data-cy="custom-textarea"
      [style.resize]="autoResize ? 'none' : null"
      [style.overflow]="autoResize ? 'hidden' : null"
      (input)="autoResize && onAutoResize($event)"
    ></textarea>
  </div>
  @if (maxLength != null && showMaxLength) {
    <small
      [id]="id + 'Maxlength'"
      class="form-text text-muted d-block text-end"
      >
      {{ (getFormElement(id)?.value?.length ?? 0) }} / {{ maxLength }}
    </small>
  }
  @if(getFormElement(id).invalid && (getFormElement(id).dirty || getFormElement(id).touched)) {
    @if(getFormElement(id).hasError('maxlength')) {
      <small
        [id]="id + 'MaxlengthError'"
        class="form-text text-danger"
        >
        Die maximale Länge von {{ getFormElement(id).errors['maxlength'].requiredLength }} Zeichen wurde überschritten (aktuell: {{ getFormElement(id).errors['maxlength'].actualLength }}).
      </small>
    }
    @if(noteText && !getFormElement(id).hasError('maxlength')) {
      <small
        [id]="id + 'HelpBlock'"
        class="form-text text-muted"
        >
        {{ noteText }}
      </small>
    }
  }
  @if (getFormElement(id)['sanitizerInfo']) {
    <div class="formcontrol-error-infotext mt-2">
      {{getFormElement(id)['sanitizerInfo']}}
    </div>
  }
</div>
